import { render, staticRenderFns } from "./SellerOrders.vue?vue&type=template&id=7d4ed37f&scoped=true"
import script from "./SellerOrders.vue?vue&type=script&lang=js"
export * from "./SellerOrders.vue?vue&type=script&lang=js"
import style0 from "./SellerOrders.vue?vue&type=style&index=0&id=7d4ed37f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4ed37f",
  null
  
)

export default component.exports